import * as R from 'ramda'
import { FETCH } from 'redux-effects-fetch'
import { startTrackingRequest, stopTrackingRequest } from './api'

/**
 * Action type for API actions.
 * @constant
 * @type {string}
 */
export const EFFECT_FETCH_API = 'EFFECT_FETCH_API'

/**
 * Redux Effects middleware.
 * @param {object} options
 * @param {string|Function} options.host
 *   Host URL e.g. `https://api.domain.com`
 * @param {Function} [options.countryCodeSelector]
 *   Function that gets Redux state and country code
 * @param {Function} [options.tokenSelector]
 *   Function that gets Redux state and returns a session token
 */
export function middleware(options) {
  const getCountryCode =
    typeof options.countryCodeSelector === 'function'
      ? options.countryCodeSelector
      : () => {}

  const getHost =
    typeof options.host === 'function' ? options.host : () => options.host

  const getToken =
    typeof options.tokenSelector === 'function'
      ? options.tokenSelector
      : () => {}

  return store => next => action => {
    if (action.type === EFFECT_FETCH_API) {
      const state = store.getState()
      const token = getToken(state)
      const host = getHost(state)
      const countryCode = getCountryCode(state)

      const nextAction = R.pipe(
        R.assocPath(['type'], FETCH),
        R.assocPath(['payload', 'url'], `${host}${action.payload.url}`),
        R.over(
          R.lensPath(['payload', 'params', 'headers', 'Authorization']),
          R.defaultTo(token)
        ),
        R.when(
          () => Boolean(countryCode),
          R.assocPath(
            ['payload', 'params', 'headers', 'Frontend-Country-Code'],
            countryCode
          )
        )
      )(action)

      const uuid = R.path(['meta', 'uuid'], nextAction)

      const dispatched = next(nextAction)

      if (uuid) {
        store.dispatch(startTrackingRequest(uuid))
        Promise.resolve(dispatched)
          .then(() => store.dispatch(stopTrackingRequest(uuid)))
          .catch(() => store.dispatch(stopTrackingRequest(uuid)))
      }

      return dispatched
    }

    return next(action)
  }
}
